import { useMutate } from '@/shared/hooks/useMutate';
import { apiPackagesNextName } from '@/entities/packages/modules/api/packages';

// Mutation: fetch the next auto-generated package name on demand (button click).
// No cache invalidation — the counter is server-authoritative and write-only.
export const usePackagesNextName = () => useMutate({ api: apiPackagesNextName });
